module.exports = __webpack_public_path__ + "static/media/PS.33a2122a.svg";